import React, { useEffect, useState } from 'react';
import { client } from '../client';
import RedeemRequest from './RedeemRequest';
import { useUser } from '../context/UserContext';
import { AiOutlineHome } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import Spinner from './Spinner';

export default function UserDashboard() {
    const { user } = useUser();
    const [userData, setUserData] = useState(null);
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            client.fetch(`*[_type == "user" && _id == "${user._id}"][0]{_id, userName, image, coins, role}`)
                .then(data => {
                    setUserData(data);
                    return client.fetch(`*[_type == "redeemRequest" && userId._ref == "${user._id}"] | order(requestedAt desc){
                        _id, amount, payoutDetails, status, requestedAt
                    }`);
                })
                .then(requestsData => {
                    setRequests(requestsData);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    }, [user]);

    if (loading) return <Spinner message="Loading..." className="dark:bg-slate-900" />;
    if (!userData) return <p className="text-center text-red-500 mt-20">User data not found.</p>;

    return (
        <div className="dark:bg-gray-900 dark:text-gray-100 min-h-screen p-8">
            <button
                onClick={() => navigate('/')}
                aria-label="Back to Home"
                className="mb-6 flex items-center gap-2 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow-md transition-colors"
            >
                <AiOutlineHome className="text-2xl" />
            </button>

            <h1 className="text-4xl font-extrabold mb-8 text-center md:text-left">Welcome, {userData.userName}</h1>

            <div className="flex flex-col md:flex-row items-center md:items-start gap-8 bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg mb-10">
                <img
                    src={userData.image || '/default-profile.png'}
                    alt={userData.userName}
                    className="w-28 h-28 rounded-full object-cover border-4 border-blue-600 dark:border-blue-500 shadow-md"
                />
                <div className="flex flex-col gap-4">
                    <p className="text-xl font-medium">
                        Coins: <span className="text-blue-600 dark:text-blue-400 font-bold">{userData?.coins || 0}</span>
                    </p>
                    <RedeemRequest userId={userData._id} currentCoins={userData.coins} />
                </div>
            </div>

            <h2 className="text-2xl font-bold mb-4">Your Redemption Requests</h2>
            {requests.length === 0 ? (
                <p className="text-gray-600 dark:text-gray-400">No redemption requests yet.</p>
            ) : (
                <div className="space-y-4">
                    {requests.map(req => (
                        <div key={req._id} className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow">
                            <p><strong>Amount:</strong> {req.amount} coins</p>
                            <p><strong>Payout Details:</strong> {req.payoutDetails}</p>
                            <p>
                                <strong>Status:</strong>{' '}
                                <span
                                    className={
                                        req.status === 'approved'
                                            ? 'text-green-500'
                                            : req.status === 'rejected'
                                            ? 'text-red-500'
                                            : 'text-yellow-500'
                                    }
                                >
                                    {req.status.charAt(0).toUpperCase() + req.status.slice(1)}
                                </span>
                            </p>
                            <p className="text-sm text-gray-500 dark:text-gray-400">
                                Requested on: {new Date(req.requestedAt).toLocaleString()}
                            </p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
